import script from "./AIImageEditor.vue?vue&type=script&setup=true&lang=js"
export * from "./AIImageEditor.vue?vue&type=script&setup=true&lang=js"

import "./AIImageEditor.vue?vue&type=style&index=0&id=6a6ee428&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6a6ee428"]])

export default __exports__